import { Breadcrumb } from 'antd';
import { LayoutCMS } from 'components';
import React from 'react';
import PostForm from './libraries';

export const PagePostFormComponent = (props: any) => {
    // set header page
    const title = 'Post'
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    {title}
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };

    // return JSX Element 
    return (
        <LayoutCMS {...layoutCMSProps}>
            <PostForm {...props} />
        </LayoutCMS>
    );
};
export default PagePostFormComponent;



// WEBPACK FOOTER //
// ./src/pages/post-form/component.tsx